import axios from ".";

/** Get notifications for a recipient. */
export const getNoticationsByUserID = (recipientId: any) => {
  return axios({
    method: "GET",
    url: `/notifications?recipientId=${recipientId}`,
  });
};

/** Get archived notifications for a recipient. */
export const getArchivedNoticationsByUserID = (recipientId: any) => {
  return axios({
    method: "GET",
    url: `/notifications/archived?recipientId=${recipientId}`,
  });
};

/** Mark a notification read/unread. */
export const markAsRead = (notificationId: any, isRead: boolean) => {
  return axios({
    method: "PATCH",
    url: `/notifications/read?notificationId=${notificationId}&read=${isRead}`,
  });
};

/** Archive a notification. */
export const markAsArchived = (notificationId: any) => {
  return axios({
    method: "PATCH",
    url: `/notifications/archived?notificationId=${notificationId}`,
  });
};

/** Mark all notifications for a recipient as read. */
export const markAllAsRead = (recipientId: any) => {
  return axios({
    method: "PATCH",
    url: `/notifications/read/all?recipientId=${recipientId}`,
  });
};
